import { Component, Input } from "@angular/core";

@Component({
	selector: "stages-tab",
	templateUrl: "./tab.component.html",
})
export class TabComponent {
	@Input() routerLink?: unknown[];
	@Input() queryParams?: Record<string, string> = {};
}
